export const layoutOptions = {
  computed: {
    pageData: {
      get() {
        return this.$store.state.updatePageData.pageData;
      },
      set(value) {
        this.$store.commit('updatePageData', value); // TODO: Set store value
      },
    },
  },
  watch: {
    /**
     * TODO: HACK: The `add_buttons` property has to be` watched due to how FormBlock.vue
     * needs to use its `sendPostRule()` which uses the infamous `$parent` reference due
     * to how the legacy components (i.e. auto/RC1/NameInsured.vue) handle the process of
     * updating the data upon an API request. Instead of refactoring that code, this watcher
     * allows these components to utilize that legacy code.
     */
    'pageData.add_buttons': function pageData(value) {
      this.$store.commit('updatePageData', {
        section_buttons: [],
        add_buttons: value,
      }); // TODO: Set store value
      this.compileSectionNames();
    },
    group: function group() {
      this.compileSectionNames();
    },
  },
};

export const none = {
  // TODO: Remove this hack that suppresses the eslint error: Prefer default export "export const uiHelpers = {""
};



// WEBPACK FOOTER //
// ./src/mixins/layoutOptions.js